import React from 'react';
import {
	AdminShell,
	MimaButton,
	MimaText,
	MetricGroup,
	MimaTable,
	ProductGrid,
} from '../../../components';
import useAdminDashboardLogic from './useAdminDashboardLogic';
import styles from '../../../assets/styles/Admin/AdminDashboard.module.scss';
import { useNavigate } from 'react-router-dom';
import constant from '../../../utils/constant';

export const AdminDashboard = () => {
	const {
		isLoading,
		orderAnalysis,
		isFetching,
		tableData,
		tableColumns,
		totalCounts,
		onLimitChange,
		limit,
		currentPage,
		setCurrentPage,
		setSearchQuery,
		productGridData,
		totalProductCounts,
		onProductLimitChange,
		isFetchingProduct,
		productLimit,
		currentProductPage,
		setCurrentProductPage,
		setSearchProductQuery,
	} = useAdminDashboardLogic();
	const navigate = useNavigate();
	return (
		<AdminShell pageTitle={'Dashboard'} childClassName={styles.dashboard}>
			<div className={styles.dashboard__header}>
				<MimaText variant="subtitleBold" color="var(--color-white)">
					Edit your website in Real time
				</MimaText>
				<MimaButton
					onClick={() => {
						navigate('/');
					}}
					title="Edit Now"
					variant="colorableSmall"
					buttonColor="var(--color-fash-primary)"
					titleColor="var(--color-fash-black-2)"
				/>
			</div>
			<div className={styles.dashboard__top}>
				<MimaText variant="subtitleBold">Overview</MimaText>
				<div>Filter</div>
			</div>
			<MetricGroup metrics={orderAnalysis} />
			<div className={styles.dashboard__top}>
				<MimaText variant="subtitleBold">Orders</MimaText>
				<MimaButton
					onClick={() => {
						navigate(constant.Routes.Admin.Orders);
					}}
					title="See all orders"
					variant="colorableSmall"
					buttonColor="var(--color-fash-black)"
				/>
			</div>
			<MimaTable
				tableData={tableData}
				tableColumns={tableColumns}
				searchPlaceholder="Search Orders"
				searchVariant="wide"
				totalItems={totalCounts}
				onLimitChange={onLimitChange}
				isLoading={isLoading}
				isFetching={isFetching}
				limit={limit}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
				hidePagination={true}
				hideSearch={true}
				emptyText="No Orders information available"
			/>
			<div className={styles.dashboard__top}>
				<MimaText variant="subtitleBold">Products</MimaText>
				<MimaButton
					onClick={() => {
						navigate(constant.Routes.Admin.Products);
					}}
					title="See all products"
					variant="colorableSmall"
					buttonColor="var(--color-fash-black)"
				/>
			</div>
			<ProductGrid
				products={productGridData}
				searchPlaceholder="Search Products"
				searchVariant="wide"
				totalItems={totalProductCounts}
				onLimitChange={onProductLimitChange}
				isLoading={isLoading}
				isFetching={isFetchingProduct}
				limit={productLimit}
				currentPage={currentProductPage}
				setCurrentPage={setCurrentProductPage}
				setSearchQuery={setSearchProductQuery}
				emptyMessage="No Products found or match search"
				hidePagination={true}
				hideSearch={true}
			/>
		</AdminShell>
	);
};

export default AdminDashboard;
